import { useSourcesStore } from './sources.store';
import { useQueryResultsStore } from './query-results.store';
import { useAlertsStore } from './alerts.store';
import { useDatabaseEventsStore } from './database-events.store';

export function cleanupSourceAnalysisData(sourceId: string): void {
    useQueryResultsStore.getState().removeEventsBySourceId(sourceId);
    useAlertsStore.getState().removeAlertsBySourceId(sourceId);
    useDatabaseEventsStore.getState().removeDatabaseEventsBySourceId(sourceId);
}

export function cleanupAfterSourceDeletion(sourceId: string): void {
    cleanupSourceAnalysisData(sourceId);
    useSourcesStore.getState().removeSource(sourceId);
}
